export function asArray<T>(value: string | T[] | undefined | null) {
  if (!value) return [];

  return Array.isArray(value) ? value : [value];
}
